import React, { Suspense, lazy } from 'react';
import { SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { BiscuitiLogo } from './components/BiscuitiLogo';

// The sign-in screen is all a visitor needs before there is a session, so the console itself
// (shell, pages, component library) is its own chunk, fetched once someone is signed in.
const App = lazy(() => import('./App'));

export default function Root() {
  return (
    <>
      <SignedOut>
        {/* Top-aligned rather than centred, with the card's height reserved: Clerk draws its
            card only after its script loads, and a centred column jumped when it did. */}
        <div className="flex min-h-dvh justify-center bg-background px-6 pt-[10vh] pb-6">
          <div className="w-full max-w-[420px]">
            <div className="mb-8 flex items-center justify-center gap-3">
              <BiscuitiLogo size={40} />
              <div>
                <div className="font-display text-[22px] font-extrabold tracking-tight">biscuiti</div>
                <div className="font-mono text-[10px] tracking-[.12em] text-muted-foreground uppercase">console</div>
              </div>
            </div>
            <div className="flex min-h-[480px] justify-center">
              <SignIn routing="hash" afterSignInUrl="/" />
            </div>
          </div>
        </div>
      </SignedOut>

      <SignedIn>
        <Suspense fallback={<div className="min-h-dvh bg-background" />}>
          <App />
        </Suspense>
      </SignedIn>
    </>
  );
}
